import PropTypes from 'prop-types';

const BandwidthIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.6 29.15L8.45 26C10.7833 23.6667 13.225 21.9167 15.775 20.75C18.325 19.5833 21.0667 19 24 19C26.9333 19 29.675 19.5833 32.225 20.75C34.775 21.9167 37.2167 23.6667 39.55 26L36.4 29.15C34.3667 27.1167 32.3167 25.6667 30.25 24.8C28.1833 23.9333 26.1 23.5 24 23.5C21.9 23.5 19.8167 23.9333 17.75 24.8C15.6833 25.6667 13.6333 27.1167 11.6 29.15ZM3.15 20.7L0 17.55C3.1 14.3833 6.70833 11.8333 10.825 9.9C14.9417 7.96667 19.3333 7 24 7C28.6667 7 33.0583 7.96667 37.175 9.9C41.2917 11.8333 44.9 14.3833 48 17.55L44.85 20.7C41.9167 17.9 38.7083 15.6667 35.225 14C31.7417 12.3333 28 11.5 24 11.5C20 11.5 16.2583 12.3333 12.775 14C9.29167 15.6667 6.08333 17.9 3.15 20.7ZM24 41.55L31.4 34.1C30.4333 33.1333 29.325 32.375 28.075 31.825C26.825 31.275 25.4667 31 24 31C22.5333 31 21.175 31.275 19.925 31.825C18.675 32.375 17.5667 33.1333 16.6 34.1L24 41.55Z"
        fill={fill}
      />
    </svg>
  </div>
);

BandwidthIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

BandwidthIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default BandwidthIcon;
